import { useQuery } from "@tanstack/react-query";
import { api } from "jiffy-api";
import type { designLab } from "common/utils/models";
import { objNamesToSnakeCase, objNamesToCamelCase } from "common/utils/helpers/cases";

export type UseDesignProjectPricesParams =
  designLab.getProjectPrices.Request["madeDesignProject"] & {
    assemblyGroupId?: string | null;
    enhancementTiers?: Record<string, string>;
  };

export function useDesignProjectPrices(params?: UseDesignProjectPricesParams) {
  return useQuery({
    enabled: !!params,
    queryKey: ["designProjectPrices", params],
    queryFn: async () => {
      if (!params) return undefined;

      const { assemblyGroupId, ...designProjectParams } = params;

      const requestParams: designLab.getProjectPrices.Request = {
        madeDesignProject: {
          variantQuantities: designProjectParams.variantQuantities,
          placements: designProjectParams.placements,
          enhancementTiers: designProjectParams.enhancementTiers
        }
      };

      // Add assembly_group_id if provided
      if (assemblyGroupId) {
        requestParams.assemblyGroupId = assemblyGroupId;
      }

      const data = await api.designLab
        .getProjectPrices(objNamesToSnakeCase(requestParams))
        .then(objNamesToCamelCase);

      const { effectivePrice, preBulkDiscountPrice, savings } = data;

      return {
        effectivePrice: Number(effectivePrice),
        preBulkDiscountPrice: Number(preBulkDiscountPrice),
        savings: Number(savings)
      };
    }
  });
}
